<template>
	<div>
		<div ref="property_input" class="property-input">
			<!-- pass $attrs to child means pass all attributes of component that arent explicit declare as props -->
			<RichTextBox :value="value" :isFocused="isFocused" :showDataMenu="showDataMenu" v-on="$listeners" v-bind="$attrs" ref="richEditor" />
		</div>
		<div v-if="isNoValue && showOpenMenuButton" class="prefix" :style="`bottom: ${suffixBottom + 1}px`">Type '/' to insert data</div>
		<div v-if="showOpenMenuButton" class="suffix-icons" :style="`bottom: ${suffixBottom}px`">
			<OpenMenuButton v-on="$listeners" />
		</div>
	</div>
</template>
<script>
import OpenMenuButton from '@/components/BlockEditor/BlockEditorParams/inputsComponents/assets/OpenMenuButton';
import InputComponentMixinBase from './mixins/InputComponentMixinBase';
export default {
	name: 'DefaultPropertyInput',
	components: { OpenMenuButton },
	mixins: [InputComponentMixinBase],
	props: {
		isFocused: { type: Boolean },
		showDataMenu: { type: Boolean },
		fixPlusButtonPad: { type: Boolean },
		value: { type: [String, Number, Boolean, Array, Object] },
	},
	methods: {
		setSuffixBottom() {
			const pixelsToAdd = this.fixPlusButtonPad ? 11 : -30;
			this.suffixBottom = this.getTextBoxHeight() + pixelsToAdd;
		},
		getTextBoxHeight() {
			return this.$refs.property_input?.getBoundingClientRect().height;
		},
	},
	computed: {
		showOpenMenuButton() {
			return this.isFocused && !this.showDataMenu;
		},
		isNoValue() {
			return !this.value || this.value === '';
		},
	},
	data() {
		return {
			suffixBottom: 0,
		};
	},
	updated() {
		this.isFocused && this.setSuffixBottom();
	},
};
</script>
<style lang="scss" scoped>
.suffix-icons {
	right: 10px;
	position: absolute;
	z-index: 1;
}
.prefix {
	left: 10px;
	font-size: 14px;
	position: absolute;
	z-index: 1;
	color: var(--insert-data-placeholder);
}
</style>
